import { render, staticRenderFns } from "./MsgTemplate.vue?vue&type=template&id=3cf9d7b4&scoped=true"
import script from "./MsgTemplate.vue?vue&type=script&lang=js"
export * from "./MsgTemplate.vue?vue&type=script&lang=js"
import style0 from "./MsgTemplate.vue?vue&type=style&index=0&id=3cf9d7b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf9d7b4",
  null
  
)

export default component.exports